import styled from "styled-components";

import { SPACING_VALUES } from "shared/config/spacing";

export const StyledHStack = styled.div((props) => {
    return {
        display: "flex",
        flexDirection: "row",
        flexWrap: props.$wrap ? "wrap" : "no-wrap",
        alignItems: props.$align,
        justifyContent: props.$justify,
        gap: props.$spacing ? SPACING_VALUES[props.$spacing] : "0",
    };
});
